import React, { useLayoutEffect } from 'react'
import Header from '../components/header/Header'
import { Outlet, useLocation } from 'react-router-dom'
import PagesHeader from '../components/header/PagesHeader'
import Footer from '../components/footer/Footer'
import PagesFooter from '../components/footer/PagesFooter'
import { useTranslation } from 'react-i18next'
import { useGetHomeDataQuery } from '../store/services/homepageApi'

const Layout = () => {
  const location = useLocation()
  const {i18n: {language}} = useTranslation()
  const {
    data: homeData,
    isError,
    isLoading,
    isFetching,
    error,
  } = useGetHomeDataQuery(language);
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
}, [location]);
  return (
    <>
      <PagesHeader />
      <Outlet />
      <PagesFooter packages={homeData?.data?.packages} />
    </>
  )
}

export default Layout
